import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import {
  fetchIdMstinspectcat,
  fetchMstareatype,
  fetchMstdamagecond,
  fetchMstinspectcat,
  selectLoading,
  selectTabMaster,
  setPermisionAreaType,
  setPermisionCategory,
  setPermisionDamage,
} from "./motorPoolSlice";

import { makeStyles, fade } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchGroupAreaFunc,
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { AreaType } from "./AreaType";
import { InspectionCategory } from "./InspectionCategory";
import { DamageConditions } from "./DamageConditions";
import { selectPagination } from "../../modules/Auth/_redux/authRedux";
import { selectMenuTab } from "../menu/menuSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const MasterTab = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const paginationSet = useSelector(selectPagination);
  const dataTabMaster = useSelector(selectTabMaster);

  const [list, setList] = useState(null);

  useEffect(() => {
    if (dataTabMaster !== null) {
      const data = dataTabMaster.childs.map((item) => item.menu_name);
      setList(data);
      setActive(data[0]);

      const permission = dataTabMaster.childs.map((item, index) => {
        if (item.menu_name === "Area Type") {
          return dispatch(setPermisionAreaType(item.permissions));
        }

        if (item.menu_name === "Inspection Category") {
          return dispatch(setPermisionCategory(item.permissions));
        }

        if (item.menu_name === "Damage Conditions") {
          return dispatch(setPermisionDamage(item.permissions));
        }
      });
    }
  }, [dataTabMaster]);

  const types = ["Area Type", "Inspection Category", "Damage Conditions"];
  const [active, setActive] = useState("");

  // area type
  const [value, setValue] = useState(0);
  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  // Inspection Category
  const [value2, setValue2] = useState(0);
  const [fields2, setFields2] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  // damage cond
  const [value3, setValue3] = useState(0);
  const [fields3, setFields3] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchGroupAreaFunc("AREA_FUNCTION"));
      await dispatch(
        fetchMstareatype({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(
        fetchMstinspectcat({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      await dispatch(
        fetchMstdamagecond({
          is_enable: "Y",
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {list && (
        <Card>
          <CardBody>
            <ButtonToolbar>
              {list.map((list) => (
                <Button
                  active={active === list}
                  onClick={() => setActive(list)}
                  variant="outline-primary"
                  className="m-2 "
                >
                  {list}
                </Button>
              ))}
            </ButtonToolbar>

            {active === "Area Type" && (
              <AreaType
                value={value}
                setValue={setValue}
                fields={fields}
                setFields={setFields}
              />
            )}
            {active === "Inspection Category" && (
              <InspectionCategory
                value={value2}
                setValue={setValue2}
                fields={fields2}
                setFields={setFields2}
              />
            )}
            {active === "Damage Conditions" && (
              <DamageConditions
                value={value3}
                setValue={setValue3}
                fields={fields3}
                setFields={setFields3}
              />
            )}
          </CardBody>
        </Card>
      )}
    </>
  );
};
